import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AnalyticsService } from './analytics.service';

export function apiUrl(path: string): string {
  if (!path.startsWith('/api/')) {
    throw new Error(`API paths must start with /api/: ${path}`);
  }

  return `${environment.apiBaseUrl}${path}`;
}

export const apiOriginInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('/api/')) {
    return next(request);
  }

  const analytics = inject(AnalyticsService);
  const traceId = analytics.createRequestTraceId();
  const flowId = analytics.currentAssessmentFlowId();
  const startedAt = performance.now();
  let headers = request.headers.set('X-Correlation-ID', traceId);
  if (flowId) headers = headers.set('X-Assessment-Flow-ID', flowId);

  return next(
    request.clone({
      url: apiUrl(request.url),
      withCredentials: true,
      headers,
    }),
  ).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          analytics.trackApiRequest(
            request.method,
            request.url,
            event.status,
            performance.now() - startedAt,
            event.headers.get('X-Correlation-ID') ?? traceId,
          );
        }
      },
      error: (error: unknown) => {
        const response = error instanceof HttpErrorResponse ? error : null;
        analytics.trackApiRequest(
          request.method,
          request.url,
          response?.status ?? 0,
          performance.now() - startedAt,
          response?.headers.get('X-Correlation-ID') ?? traceId,
        );
      },
    }),
  );
};
